import { render, staticRenderFns } from "./PartneredTenant.vue?vue&type=template&id=7468547c&"
import script from "./PartneredTenant.vue?vue&type=script&lang=ts&"
export * from "./PartneredTenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports